import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getCustomers = async () => {
  const response = await axiosInstance.get('Customer/get-customers');
  return response.data;
};

export const getCustomerById = async (id) => {
  const response = await axiosInstance.get(`Customer/get-customer/${id}`);
  return response.data;
};

export const addCustomer = async (customer) => {
  const response = await axiosInstance.post('Customer/add-customer', customer);
  return response.data;
};

export const updateCustomer = async (id, customer) => {
  const response = await axiosInstance.put(`Customer/update-customer/${id}`, customer);
  return response.data;
};

export const deleteCustomer = async (id) => {
  await axiosInstance.delete(`Customer/delete-customer/${id}`);
};

export const lookupCompanyByVAT = async (vatNumber) => {
  const response = await axiosInstance.get(`Company/lookup-cbe/${vatNumber}`);
  return response.data;
};

export const searchCustomers = async (inputValue) => {
  if (!inputValue || inputValue.length < 3) return [];

  let params = {};
  if (/^\d+$/.test(inputValue)) {
    // If input is all digits, search by VAT or ID
    params.vatNumber = inputValue;
  } else {
    // Otherwise search by name
    params.name = inputValue;
  }

  try {
    const response = await axiosInstance.get('customer/search', { params });
    
    
    // Extract payload from response
    const customers = response.data.payload || response.data || [];
    
    
    // ✅ Map backend response to frontend format - ADD CustomerPeppolId!
    return customers.map((c) => ({
      Id: c.Id,
      Name: c.Name,
      CompanyName: c.CompanyName,
      Email: c.Email,
      Phone: c.PhoneNumber || c.MobilePhone,
      VATNumber: c.VATNumber,
      Street: c.Street,
      Box: c.Box,
      PostCode: c.PostCode,
      City: c.City,
      Country: c.Country,
      MobilePhone: c.MobilePhone,
      CompanyId: c.CompanyId,
      IsActive: c.IsActive,
      CustomerPeppolId: c.CustomerPeppolId, // ✅ ADD THIS LINE!
      CreatedDate: c.CreatedDate,
      IsDeleted: c.IsDeleted,
      // For display purposes
      value: c.Id,
      label: `${c.CompanyName || c.Name} (ID: ${c.Id})${c.Email ? " - " + c.Email : ""}${c.VATNumber ? " - VAT: " + c.VATNumber : ""}`,
    }));
  } catch (error) {
    console.error('❌ Error searching customers:', error);
    throw error;
  }
};